import React, {useCallback, useContext, useMemo} from 'react';
import {Typography} from "@material-ui/core";
import {SearchContext} from "../../lib/contexts";
import legal_questions from "../../lib/constants/legal_questions.json"
const RandomQuote = () => {
   const {
      state: { resultsLoading, searchResults },
      actions: { forceSearch, setQuery },
   } = useContext(SearchContext);
   const quotesList = useMemo(()=> legal_questions ? legal_questions.questions : [], []);
   // eslint-disable-next-line
   const legal_question = useMemo(()=>legal_questions ? quotesList[Math.floor(Math.random()*quotesList.length)] : '', [searchResults]);
   const handleSelection = useCallback((event,value)=>{
      event.preventDefault();
      setQuery(value);
      forceSearch();
   },[forceSearch, setQuery])
   return(<>{
      !resultsLoading && !searchResults && legal_question && <>
         <Typography color="textSecondary" gutterBottom style={{textAlign:'center',margin:'10px auto 150px',color: '#fafafa'}}>
            <a href={"?q="+encodeURI(legal_question.question)}  style={{color: '#fafafa', textDecoration:'none', borderWidth:0, borderBottomWidth:1, borderStyle:'solid', borderColor: '#fafafa'}}>"{legal_question.question}"</a>
         </Typography>
      </>
      }</>)
};
export default RandomQuote;
